import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import http from '@lib/http-client'
import { AddressStore, IUserAddress } from './types'

export const useAddressStore = create<AddressStore>()(
  devtools(set => ({
    getUserAddress: async (userId: number) => {
      try {
        const endpoint = `/user/${userId}/address`
        const response = await http.get(endpoint)
        return response
      } catch (error) {
        console.error('Error fetching user address:', error)
        return null
      }
    },
    setUserAddress: async (
      userId: number,
      addressData: IUserAddress
    ): Promise<{ success: boolean; errorMessage?: string }> => {
      try {
        const endpoint = `/user/${userId}/address`
        // the endpoint answers failures with a body, so read it instead of throwing
        const response = await http.post(endpoint, addressData, {
          validateStatus: () => true
        })
        return {
          success: !!response?.success,
          errorMessage: response?.errorMessage || undefined
        }
      } catch (error) {
        return { success: false }
      }
    }
  }))
)
